import axios from "axios";
import authHeader from "@/services/auth-header";

const API_URL = `${process.env.VUE_APP_API_BASE_URL}/api/v2/Common/Security`;

class SecurityService {
  encrypt(val) {
    return axios
      .post(
        `${API_URL}/encrypt`,
        {
          stringBody: val,
        },
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }

  decrypt(val) {
    return axios
      .post(
        `${API_URL}/decrypt`,
        {
          stringBody: val,
        },
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }
}

export default new SecurityService();
